import styled from 'styled-components';
import { colorUsage } from 'stylesheet';
import { Calendar } from 'theme/icons';
var StyledCalendar = styled(Calendar).withConfig({
  displayName: "DateInputstyle__StyledCalendar",
  componentId: "sc-1rz46ca-0"
})(["& path{fill:", ";}"], colorUsage.defaultIconColor);
export { StyledCalendar };